"use client"

import { useSyncExternalStore } from "react"
import { AdCard } from "@/components/ad-card"
import { AD_CONFIGS } from "@/lib/ad-config"

// Picked once on the client, then stable. Module scope keeps Math.random() out
// of render and gives useSyncExternalStore the identical reference it needs.
const subscribeNever = () => () => {}
let cachedAd1: (typeof HIGH_PAYOUT_ADS)[number] | null = null
let cachedAd2: (typeof ADDITIONAL_ADS)[number] | null = null
const getAd1 = () => {
  if (!cachedAd1) cachedAd1 = HIGH_PAYOUT_ADS[Math.floor(Math.random() * HIGH_PAYOUT_ADS.length)]
  return cachedAd1
}
const getAd2 = () => {
  if (!cachedAd2) cachedAd2 = ADDITIONAL_ADS[Math.floor(Math.random() * ADDITIONAL_ADS.length)]
  return cachedAd2
}

const HIGH_PAYOUT_ADS = [
  AD_CONFIGS.wayfair["300x250"],
  AD_CONFIGS.lg["300x250"],
]
const ADDITIONAL_ADS = [
  AD_CONFIGS.ajmadison["300x250"],
  AD_CONFIGS.fridgefilters["300x250"],
  AD_CONFIGS.sharpSquare["300x250"],
]

interface TagSidebarWithAdsProps {
  children: React.ReactNode
}

/**
 * Sidebar layout for blog tag pages: ad above Related Tags, ad below.
 * Matches /blogs/news sidebar ad pattern (same ad pools, random on client).
 */
export function TagSidebarWithAds({ children }: TagSidebarWithAdsProps) {
  // Random pick lives in a module-level cache read through
  // useSyncExternalStore, not pushed into state from an effect. Math.random()
  // must not run during render (react-hooks/purity), and caching keeps the
  // snapshot reference stable so the ads do not re-roll on unrelated
  // re-renders. The first (deterministic) entry is still what the server and
  // the hydration pass render, exactly as the useState defaults did.

  const ad1 = useSyncExternalStore(subscribeNever, getAd1, () => HIGH_PAYOUT_ADS[0])
  const ad2 = useSyncExternalStore(subscribeNever, getAd2, () => ADDITIONAL_ADS[0])

  return (
    <div className="sticky top-24 space-y-5 w-full">
      {ad1 && <AdCard {...ad1} variant="blog" className="w-full" />}
      {children}
      {ad2 && <AdCard {...ad2} variant="blog" className="w-full" />}
    </div>
  )
}
